import { TABLE_PAGE_SIZE_REPORTS } from "../../constants";
import { ReportPeriodGroupingEnum } from "../../enums";
import { ISelectListItem, RydeUiUnit } from "../common.models";
import { OperatorDescriptor } from "../filters.models";

/* eslint-disable @typescript-eslint/no-explicit-any */
export type ColumnTotalType =
  | "SUM"
  | "AVG"
  | "MIN"
  | "MAX"
  | "ROWS"
  | "TEXT"
  | "NO_TOTAL"
  | "PERCENT"
  | "WEIGHTED_AVG";
export type ColumnCalcType = "SUM" | "AVG" | "MIN" | "MAX" | "PERCENT";

export interface IReportColumn {
  isIdColumn?: boolean;
  isDateColumn?: boolean;
  isCheckboxValue?: boolean;
  columnWidth?: number;
  totalType?: ColumnTotalType;
  // WEIGHTED_AVG: template key of the per-group weight (e.g. a valid-value count) used to weight this average.
  totalWeightColumn?: string;
  // PERCENT: template keys whose per-group values are summed for the grand-total numerator / denominator.
  totalNumeratorColumn?: string;
  totalDenominatorColumn?: string;
  columnTitleTranslationKey: string;
  prefixTotalTranslationKey?: string;
  prefixTotalDelimiter?: string;
  skipValueProcessing?: boolean;
  isPrice?: boolean;
  isHiddenByDefault?: boolean;
  isHiddenFromView?: boolean;
  isPercentage?: boolean;
  translationMap?: Record<string, string>;
  dateFormat?: string;
}

export interface IReportGridColumn extends IReportColumn {
  columnTemplateKey: string;
  uiTableColumn: string;
  isSummaryColumn: boolean;
  isFlexGroupingColumn: boolean;
  isPeriodGroupingColumn?: boolean;
  periodGrouping?: ReportPeriodGroupingEnum;
  fieldExpression: string;
  translationKey: string;
}

export interface IFlexGroupingColumns {
  [templateKey: string]: IReportColumn;
}

export interface IReportTemplateFilters {
  [templateKey: string]: {
    dropdownSource?: RydeUiUnit;
    selectItemsSource?: ISelectListItem[];
    filterFieldTypeId?: number;
  };
}

export interface IReportCriteriaFilters {
  [templateKey: string]: { value: any };
}

/**
 * Operator-based report filters (RYDE-8067): mongo-style descriptors keyed by template filter/column key,
 * ANDed server-side on top of `filters`. Unknown keys and malformed descriptors are rejected with 422 by
 * the backend — never silently ignored like legacy `filters` keys.
 */
export interface IReportCriteriaWhere {
  [templateKey: string]: OperatorDescriptor;
}

export interface IReportCriteriaFlexGrouping {
  periodGrouping?: ReportPeriodGroupingEnum;
  groupingParams?: string[];
}

export interface IReportLayout {
  columns: IReportGridColumn[];
}

export interface IReportHavingValueOverload {
  templateKey: string;
  overloadValue: any;
}

export interface IReportSortItemOverload {
  templateKey: string;
  desc: boolean;
}

export const defaultReportPaginationState = {
  pageIndex: 0,
  pageSize: TABLE_PAGE_SIZE_REPORTS,
};
